import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { toggleEnable } from '@/api/common';
let default_1 = class default_1 extends Vue {
  async toggleEnable(value) {
    if (this.disabled) {
      this.$message({
        message: 'Operation not permitted!',
        type: 'warning'
      });
      return;
    }
    const newValue = !this.value;
    try {
      this.url = null; // remove to enable value change
      if (this.url) {
        const data = await toggleEnable(this.url, {
          enabled: newValue
        });
        if (data) {
          this.$emit('input', data.enabled);
        }
      }
    } catch (error) {
      if (error) {
        this.$message(error.toString());
      }
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "value", void 0);
__decorate([Prop({
  default: ''
})], default_1.prototype, "url", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "disabled", void 0);
default_1 = __decorate([Component({
  name: 'Enabled'
})], default_1);
export default default_1;